export default __webpack_public_path__ + "static/media/third-pickup-status.07174ad3.svg";